import styled, { css } from 'styled-components';

import { Container as BaseFeaturesContainer } from '@/pages/feature-list/styled';
import { Container as BaseFooterContainer } from '@/pages/footer/styled';

export const ActionsContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-auto-rows: 2.5rem;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: ${spacing.km6};
    margin: ${spacing.km6} auto;
    width: 36.5rem;
    max-width: 100%;
    justify-content: center;
    align-items: center;
  `}

  > * {
    grid-column: auto/span 1;
  }

  > *:first-child {
    grid-column: auto/span 3;
  }
`;

export const FeaturesContainer = styled(BaseFeaturesContainer)`
  ${({ theme: { breakpoint, color, spacing, border } }) => css`
    padding: ${spacing.km4};
    background-color: ${color.background.neutral.default};
    border: ${border.width.thinner} ${border.style.solid} ${color.border.neutral.default};

    @media screen and (min-width: ${breakpoint.md.minWidth}) {
      padding: ${spacing.km10} ${spacing.km12};
    }
  `}
`;

export const FeatureItem = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    width: 100%;
    grid-gap: ${spacing.km4};

    > div:last-child {
      display: grid;
      grid-gap: ${spacing.km2};
    }
  `}
`;

export const FooterContainer = styled(BaseFooterContainer)``;

export const FooterItem = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-gap: ${spacing.km4};
  `}
`;
export const FooterLogoContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-gap: ${spacing.km6};
    grid-auto-flow: column;
    grid-auto-columns: max-content;
  `}
`;
